import { FlexContainer } from 'features/common/components/FlexContainer';
import { PromoCodeTag } from '../PromoCodeTag';

import { Price, Text } from '../OrderSummary.styles';
import { TicketType } from 'features/common/types';

export const TicketRow = (
	{ name, initialPrice, ID, quantity, promoCodeApplied, priceWithNoDiscount }: TicketType,
	isPunchup?: boolean
) => (
	<FlexContainer key={ID} justifyContent="space-between">
		<FlexContainer gap="8px">
			<Text isPunchup={isPunchup}>{`${name} (${quantity})`}</Text>
			{promoCodeApplied && <PromoCodeTag />}
		</FlexContainer>
		<FlexContainer flexDirection="column">
			{!!promoCodeApplied && (
				<Price className="promoCodeApplied" isPunchup={isPunchup}>
					${priceWithNoDiscount}
				</Price>
			)}
			<Price isPunchup={isPunchup}>${initialPrice}</Price>
		</FlexContainer>
	</FlexContainer>
);
